module.exports = __webpack_public_path__ + "static/media/packs.7be56440.png";